export default {
  loadBtn: (state) => {
    return state.loadBtn;
  },

  sortOptions: () => {
    let option = [
      { label: "جدیدترین", id: 1 },
      { label: "قدیمی ترین", id: 2 },
      { label: "پرطرفدار ترین", id: 3 },
    ];
    return option;
  },

  config: (state) => {
    return state.config;
  },

  newsletterDisplay: (state) => {
    return state.newsletterDisplay;
  },

  customerBanners: (state) => {
    return state.customerBanners;
  },
  customerOpinion: (state) => {
    return state.customerOpinion;
  },
  honorBanners: (state) => {
    return state.honorBanners;
  },
  team: (state) => {
    return state.team;
  },
  sliders: (state) => {
    return state.sliders;
  },
  services: (state) => {
    return state.services;
  },
  servicesById: (state) => {
    return state.servicesById;
  },

  tutorials: (state) => {
    return state.tutorials;
  },
  tutorialsPage: (state) => {
    return state.tutorialsPage;
  },
  tutorialHome: (state) => {
    return state.tutorialHome;
  },
  tutorial: (state) => {
    return state.tutorial;
  },
  tutorialsPageTotal: (state) => {
    return state.tutorialsPageTotal;
  },

  products: (state) => {
    return state.products;
  },
  productsHome: (state) => {
    return state.productsHome;
  },
  productsPage: (state) => {
    return state.productsPage;
  },
  product: (state) => {
    return state.product;
  },
  productsPageTotal: (state) => {
    return state.productsPageTotal;
  },
  relatedProducts: (state) => {
    return state.relatedProducts;
  },

  blogs: (state) => {
    return state.blogs;
  },
  relatedBlogs: (state) => {
    return state.relatedBlogs;
  },
  blogHome: (state) => {
    return state.blogHome;
  },
  blogsPage: (state) => {
    return state.blogsPage;
  },
  blogsPageTotal: (state) => {
    return state.blogsPageTotal;
  },
  blog: (state) => {
    return state.blog;
  },

  galleries: (state) => {
    return state.galleries;
  },
  galleryPage: (state) => {
    return state.galleryPage;
  },
  gallery: (state) => {
    return state.gallery;
  },
  galleryList: (state) => {
    return state.galleryList;
  },
  galleryPageTotal: (state) => {
    return state.galleryPageTotal;
  },

  categories: (state) => {
    return state.categories;
  },
  category: (state) => {
    return state.category;
  },
  menus: (state) => {
    return state.menus;
  },

  socials: (state) => {
    return state.socials;
  },

  cities: (state) => {
    return state.cities;
  },
  citiesOptions: (state) => {
    const citiesOptions = [];
    state.cities.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      citiesOptions.push(pushItem);
    }
    return citiesOptions;
  },
  states: (state) => {
    return state.states;
  },
  activityField: (state) => {
    return state.activityField;
  },
  activityFieldOptions: (state) => {
    const activityFieldOptions = [];
    state.activityField.forEach(func);
    function func(item) {
      const pushItem = {
        id: item.id,
        label: item.title,
      };
      activityFieldOptions.push(pushItem);
    }
    return activityFieldOptions;
  },

  comments: (state) => {
    return state.comments;
  },
  commentsLength: (state) => {
    return state.commentsLength;
  },

  posters: (state) => {
    return state.posters;
  },

  dynamicPageContent: (state) => {
    return state.dynamicPageContent;
  },

  aboutPage: (state) => {
    return state.aboutPage;
  },
  contactPage: (state) => {
    return state.contactPage;
  },

  support: (state) => {
    return state.support;
  },

  rules: (state) => {
    return state.rules;
  },

  methodOfIntroductions: (state) => {
    return state.methodOfIntroductions;
  },
};
